(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.FacebookPublicPresence = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'Facebook public presence data by day',
            channelName: sourceDetails[sources.FACEBOOK].name,
            postName: sourceDetails[sources.FACEBOOK].postName,

            storageDimensions: [
                'companyId',
                'day'
            ],

            availableDimensions: [
                'companySetId',
                'week',
                'month'
            ],

            fields: {
                audience: {
                    name: 'Page Fans',
                    collection: collection.AUDIENCE,
                    dataType: dataType.INTEGER
                },
                followers_count: {
                    name: 'Page Followers',
                    collection: collection.AUDIENCE,
                    dataType: dataType.INTEGER
                },
                talking_about: {
                    name: 'Talking About',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod
            ]
        };
    }
})();
